<template>
  <b-card class="p-1">
    <div class="d-flex justify-content-between align-items-center mb-1">
      <b-form-group class="w-50 mb-0">
        <b-input-group size="sm">
          <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Wyszukaj po nazwie, typie, tagu" />
          <b-input-group-append>
            <b-button :disabled="!filter" @click="filter = ''"> Wyczyść </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <b-button
        :to="{ name: 'downloadable-files-create' }"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        type="submit"
        variant="primary"
        class="btn">
        Dodaj
      </b-button>
    </div>
    <b-table
      responsive
      bordered
      striped
      hover
      :items="files"
      :fields="fields"
      :filter="filter"
      :filter-included-fields="filterOn">
      <template #cell(actions)="row">
        <div class="d-flex flex-column align-items-center">
          <b-button
            :to="{ name: 'downloadable-files-edit', params: { id: row.item.id } }"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="btn table-btn"
            size="sm">
            Edytuj
          </b-button>
          <b-button class="mt-1 table-btn" variant="danger" size="sm" @click="destroy(row.item)"> Usuń </b-button>
        </div>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import NotificationMixin from '@/mixins/NotificationMixin';

import { all, destroy } from '@/http/downloadable-files';

import { LanguageFormatter } from '@/formatters/LanguageFormatter';

export default {
  mixins: [NotificationMixin],

  data() {
    return {
      files: [],
      filter: '',
      filterOn: [],
      fields: [
        { key: 'name', label: 'Nazwa', sortable: true },
        { key: 'type', label: 'Typ pliku', sortable: true },
        { key: 'tag.name', label: 'Tag', sortable: true },
        { key: 'is_public', label: 'Publiczny', sortable: true, formatter: (value) => (value ? 'Tak' : 'Nie') },
        { key: 'priority', label: 'Priorytet', sortable: true },
        {
          key: 'lang',
          label: 'Język',
          formatter: (val) => {
            return LanguageFormatter(val);
          },
          sortable: true,
        },
        { key: 'actions', label: 'Akcje', class: 'w-25' },
      ],
    };
  },

  async mounted() {
    await this.fetchFiles();
  },

  methods: {
    async fetchFiles() {
      try {
        const { data } = await all({ lang: 'pl' });

        this.files = data.data;
      } catch (error) {
        this.showErrorNotification(
          'Problem z pobraniem danych',
          'Wystąpił błąd podczas pobierania plików. Skontaktuj się ze swoim developerem.',
        );
      }
    },
    destroy(jobOffer) {
      this.$swal({
        title: 'Jesteś pewny?',
        text: 'Czy chcesz usunąć ten plik?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Usuń',
        cancelButtonText: 'Anuluj',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          destroy(jobOffer.id)
            .then(() => {
              this.showSuccessNotification('Plik usunięty', 'Plik został usunięty.');
              this.fetchFiles();
            })
            .catch(() => {
              this.showErrorNotification(
                'Problem z usunięciem pliku',
                'Wystąpił błąd podczas usuwania pliku. Skontaktuj się ze swoim developerem.',
              );
            });
        }
      });
    },
  },
};
</script>

<style lang="scss"></style>
